import { images } from "../../../assets";


export const requiredDocModalConfig = {
  deleteDocument: {
    img: images.IconEraseRed,
    mainTitle: "¿Quieres borrar este documento?",
    mainText: "Una vez borrado, no podrá volver a recuperarlo.",
    buttonText: "Eliminar",
    className: "error",
  },
  cancelSign: {
    img: images.IconWarningYellow,
    mainTitle: "¿Seguro que desea continuar?",
    mainText: "Se cancelará la firma previamente solicitada",
    buttonText: "Continuar",
    closeButtonText: "Cancelar",
    className: "error",
  },
  replaceDocument: {
    img: images.IconWarningYellow,
    mainTitle: "¿Desea sustituir el documento existente por el seleccionado?",
    mainText: "Si continua con este proceso perderá el documento anterior.",
    buttonText: "Reemplazar",
    closeButtonText: "Cancelar",
    className: "warning",
  },
  maxSize: {
    img: images.IconWarningYellow,
    mainTitle: "Aviso de documentación",
    mainText: "La documentación adjunta supera el máximo del tamaño establecido (5MB).",
    secondaryText: "Por favor, corrija antes de continuar.",
    buttonText: "Aceptar",
    noSecondaryButton: true,
    className: "info",
  },
  requiredDocs: {
    img: images.IconWarningYellow,
    mainTitle: "Faltan documentos obligatorios",
    mainText: "Debe adjuntar los siguientes documentos obligatorios para poder continuar el proceso:",
    buttonText: "Aceptar",
    noSecondaryButton: true,
    className: "warning",
  }
};